import materialTheme from "./material";
import grayscaleTheme from "./grayscale";
export default {
  material: materialTheme,
  grayscale: grayscaleTheme
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/victory-theme/victory-theme.js
// module id = ./node_modules/victory-core/es/victory-theme/victory-theme.js
// module chunks = 1